import * as z from "zod";

import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

// Hourly job config schema
export const hourlyJobConfigSchema = z
  .object({
    rate: z
      .number({
        required_error: REQUIRED_MESSAGE,
        invalid_type_error: "Rate must be a number",
      })
      .min(0, { message: "Rate must be zero or greater" }),
    currency: z
      .string({
        required_error: REQUIRED_MESSAGE,
        invalid_type_error: "Invalid currency",
      })
      .min(1, "Currency is required"),
    billing_frequency: z.enum(["weekly", "monthly", "yearly"], {
      required_error: REQUIRED_MESSAGE,
    }),
    billing_by_week_day: z.number().min(0).max(6).nullable().optional(),
    billing_by_month_date: z.number().min(1).max(31).nullable().optional(),
    billing_by_month: z.number().min(0).max(11).nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.billing_frequency === "weekly") {
      if (data.billing_by_week_day === null || data.billing_by_week_day === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: REQUIRED_MESSAGE,
          path: ["billing_by_week_day"],
        });
      }
    } else if (data.billing_frequency === "monthly") {
      if (data.billing_by_month_date === null || data.billing_by_month_date === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: REQUIRED_MESSAGE,
          path: ["billing_by_month_date"],
        });
      }
    } else if (data.billing_frequency === "yearly") {
      if (data.billing_by_month === null || data.billing_by_month === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: REQUIRED_MESSAGE,
          path: ["billing_by_month"],
        });
      }
    }
  });
